/** @format */

import 'react-perfect-scrollbar/dist/css/styles.css';
import './style/style.scss';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import store from 'src/store';
import { AuthProvider } from 'src/contexts/KeyCloakContext';
import App from 'src/App';
import SplashScreen from './components/SplashScreen';
import { getAppLanguage } from 'src/utils/locale';

import { trackDataLayer } from './utils/dataLayer';
window.trackDataLayer = trackDataLayer;

const lang = getAppLanguage();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <Suspense fallback={<SplashScreen />}>
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </Suspense>
  </StrictMode>
);

serviceWorker.register();
document.getElementsByTagName('html')[0].setAttribute('lang', lang);
